export default "__VITE_ASSET__57879ff5__"